import { format, isSameYear, isToday } from "date-fns";
import { cs } from "date-fns/locale";

const formatDividerLabel = (date) => {
    const time = format(date, "HH:mm");

    if (isToday(date)) return `Dnes ${time}`;

    return format(date, isSameYear(date, new Date()) ? "d. M." : "d. M. yyyy", { locale: cs })
        .replace(/^./, (char) => char.toUpperCase())
        .concat(` ${time}`);
};

const MessageTimestampDivider = ({ date }) => (
    <div className="chat_timestamp_divider body_smallest" role="separator">
        <span className="chat_timestamp_divider_text">{formatDividerLabel(new Date(date))}</span>
    </div>
);

export default MessageTimestampDivider;